module.exports = __webpack_public_path__ + "media/images/instructions/aws-account-id-b2aa28df3088652516565ddb2738b708.png";